import { render, staticRenderFns } from "./LabelSetup.vue?vue&type=template&id=1f08c18f&"
import script from "./LabelSetup.vue?vue&type=script&lang=js&"
export * from "./LabelSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports